<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="isCreate ? newRules: updateRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>
            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div class="w-full" 
                v-if="role === 3 && 
                  (isCreate && (form.roleId == 7 || form.roleId == 8) || (!isCreate && form.idDistribuidor))
                  ">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('distributors.entity_name')}}</label>
                <div class="flex justify-between">
                  <el-form-item prop="idDistribuidor" class="w-full">
                    <base-el-select class="w-full" :options="distribuidores" v-model="form.idDistribuidor" clearable filterable
                      :loading="loadingDistribuidores" :disabled="!isCreate" />
                  </el-form-item>
                  <base-button v-if="!isCreate" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailDistributor" :loading="isGeneralLoading" type="button" />
                </div>
              </div>

              <div class="w-full" 
                v-if="(role === 7 || role === 8 || role === 3) &&
                (form.roleId !== 3 && form.roleId !== 7 && form.roleId !== 8)">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
                <div class="flex justify-between">
                  <el-form-item prop="clienteId" class="w-full">
                    <base-el-select class="w-full" :options="clientes" v-model="form.clienteId" clearable filterable
                      :loading="loadingClientes" :disabled="!isCreate" />
                  </el-form-item>
                  <base-button v-if="!isCreate" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading" type="button" />
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('users.entity_name')}}</label>
                <el-form-item prop="name">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.name"
                    maxlength='50'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$tc('users.email', 1)}}</label>
                <el-form-item prop="email">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.email"
                    maxlength='255'
                  />
                </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$tc('app.role', 1)}}</label>
              <el-form-item prop="roleId">
                <base-el-select class="w-full" :options="roles" v-model="form.roleId" :disabled="isSameUser" />
              </el-form-item>
            </div>
            <div v-if="(hasAADIntegration || hasSAML2Integration) && form.roleId !== 9" class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('users.tipo_auth')}}</label>
              <el-form-item prop="tipoAuth">
                <base-el-select class="w-full" :options="tiposAuthFiltered" v-model="form.tipoAuth" clearable :disabled="isSameUser || (!hasAADIntegration && !hasSAML2Integration)" />
              </el-form-item>
            </div>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.language') }}</label>
              <el-form-item prop="idioma">
                <base-el-select class="w-full" :options="tiposIdioma" v-model="form.idioma" :option-label="langOptionLabel" />
              </el-form-item>
            </div>
            <div v-if="form.roleId !== 7 && form.roleId !== 9" class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" :disabled="(isSameUser && isRoleUserOrConsulta) || [3, 8].includes(form.roleId) || !hasPermissionEditVisiblity" v-model="form.verTodoStatuses" :active-text="$t('configurations.ver_todo_statuses')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <el-switch class="switch-text break-normal" :disabled="(isSameUser && isRoleUserOrConsulta) || [3, 8].includes(form.roleId) || !hasPermissionEditVisiblity" v-model="form.verTodoCompanies" :active-text="$t('configurations.ver_todo_companies')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>
            <div class="lg:mb-4">
              <!-- Se muestran para los tipos de auth Local(0), MixtoAAD(2), MixtoSAML2(4)  -->
              <div v-if="isCreate && [0, 2, 4].includes(form.tipoAuth)" class="lg:mb-2">
                <base-password-form-item v-model="form.password" autocomplete="new-password" />
                <base-password-form-item v-model="form.repeat_password" :password="form.password" autocomplete="new-password" repeat />
              </div>
            </div>
            <div class="lg:mb-2">
              <div v-if="!isCreate && form.created_at" class="mandatory">
                <base-ro-input
                  :label="$t('app.created_at')"
                  :data="form.created_at"
                />
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <user-generate-password-dialog
        :dialogOpen="showGeneratePassword"
        :email="this.$route.params.id"
        @toggleDialog="toggleDialogs"
      />

    </template>
  </detail-layout>
</template>

<script>
import { bus } from '@/main'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getClients } from '@/services/clients/getClients'
import { getUser } from '@/services/configurations/getUser'
import { newUser } from '@/services/configurations/newUser'
import { updateUser } from '@/services/configurations/updateUser'
import { i18n } from '@/i18n'
import UserGeneratePasswordDialog from '@/components/UserGeneratePasswordDialog.vue'
import { email as emailRegex } from '@/utils/regex'
import { getDistributors } from '@/services/distributors/getDistributors'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayout,
    UserGeneratePasswordDialog,
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      distribuidores: [],
      loadingDistribuidores: false,
      loadingClientes: false,
      header: {
        title: 'DETALLE DE USUARIO',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/users'
      },
      loadedFirstTime: false,
      form: this.getDefaultForm(),
      clientes: [],
      tooltipVerTodoStatuses: i18n.t('tooltip.ver_todo_statuses'),
      tooltipVerTodoCompanies: i18n.t('tooltip.ver_todo_companies'),
      toolAccesoAAD: i18n.t('tooltip.acceso_AAD'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      updateRules: {
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        roleId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        tipoAuth: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        idioma: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
      },
      newRules: {
        clienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        roleId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        tipoAuth: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
      },
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    hasPermissionEditVisiblity () {
      return this.$store.getters['auth/hasPermissionEditVisiblity']
    },
    roles: function () {
      var roles = this.$store.getters['config/ROLES'].filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })

      if (!this.hasAutofactura) {
        roles = roles.filter(filter => filter.id !== 9)
      }

      // Al crear o mientras carga la vista sin usuario, permitimos todos
      if (!(this.isCreate || !this.form.staticRoleId)) {
        const rolesDistributor = [7, 8]
        if (this.form.staticRoleId === 3) {
          // Rol SuperAdministrador
          roles = roles.filter(x => x.id === 3)
        } else if (rolesDistributor.includes(this.form.staticRoleId)) {
          // Rol SuperAdminDistribuidor o AdminDistribuidor
          roles = roles.filter(x => rolesDistributor.includes(x.id))
        } else {
          // Rol Adminisitrador, Usuario o UsuarioConsulta
          roles = roles.filter(x => !rolesDistributor.includes(x.id) && x.id !==3)
        }
      }
      return roles
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasAutofactura: function () {
      return !!this.$store.getters['auth/hasAutofacturaModule']
    },
    hasAADIntegration: function () {
      return !!this.$store.getters['auth/hasModuleIntegracionAAD']
    },
    hasSAML2Integration: function () {
      return !!this.$store.getters['auth/hasModuleSAML2']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    getIdUsuarioLogged: function () {
      return this.$store.getters['auth/user'].idUsuario
    },
    isSameUser: function () {
      return this.getIdUsuarioLogged === parseInt(this.id)
    },
    tiposAuthFiltered: function () {
      var arrayAuthTypes = this.$store.getters['config/TIPOS_AUTH']
      if (!this.hasAADIntegration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['AAD', 'Mixto'].includes(x.key))
      }
      if (!this.hasSAML2Integration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['SAML2', 'MixtoSAML2'].includes(x.key))
      }
      return arrayAuthTypes
    },
    tiposIdioma: function () {
      return this.$store.getters['config/TIPOS_IDIOMA']
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.roleId': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandlerRole'
    },
  },
  created: async function () {
    const localUser = this.$store.getters['auth/user']
    this.localUserId = localUser.IdUsuario
    const breadcrumbs = []

    if (this.role === 7 || this.role === 8 || this.role === 3) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: i18n.t('configurations.header')
      })
    }
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(`${dataClients.msgError} [${dataClients.codError}]`)
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: x.idCliente }))
      this.loadingClientes = false

      if (this.role === 3) {
        this.loadingDistribuidores = true
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(`${dataDistributors.msgError} [${dataDistributors.codError}]`)
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: x.IdDistribuidor }))
        this.loadingDistribuidores = false
      }
    }

    if (!this.isCreate) {
      await this.downloadData(this.id)
      if (this.$route.params.noticeType !== undefined && this.$route.params.noticeType !== null && this.$route.params.noticeType !== '') {
        this.header.url = 'notices/usuariospasswordcaducar'
        breadcrumbs.push({ path: 'notices/usuariospasswordcaducar', name: i18n.t('avisos.usuariospasswordcaducar') })
      } else {
        breadcrumbs.push({ path: 'configurations/users', name: i18n.t('users.header') })
      }
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    } else {
      breadcrumbs.push({ path: 'configurations/users', name: i18n.t('users.header') })
      breadcrumbs.push({
        path: '',
        name: i18n.t('users.new_user')
      })
      this.form.idioma = 'es'
    }
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        company: '',
        active: false,
        idDistribuidor: '',
        created_at: '',
        password: '',
        repeat_password: '',
        clienteId: '',
        roleId: '',
        verTodoStatuses: true,
        verTodoCompanies: true,
        tipoAuth: 0,
        staticRoleId: '',
        idioma: '',
      }
    },
    langOptionLabel: function (option) {
      return this.isSameUser ? option.localName : option.name
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    goDetailDistributor () {
      const id = this.form.idDistribuidor
      this.$router.push({ name: 'configurations/distributors/details', params: { id } })
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    watchFormHandlerRole: function () {
      // TODO Control cambio a rol Consulta
      if (this.form.roleId === 4 && this.isCreate) {
        if (this.form.verTodoStatuses === false || this.form.verTodoCompanies === true) {
          this.form.verTodoStatuses = true
          this.form.verTodoCompanies = false
          const role = this.roles.find(x => x.id === this.form.roleId)?.name ?? ''
          this.doFeedback(i18n.t('feedback.info.role_permissions_overwritten', { rol: role }), 'info')
        }
      }
      if (!this.loadedFirstTime && (this.form.roleId === 3 || this.form.roleId === 8)) {
        if (this.form.verTodoStatuses === false || this.form.verTodoCompanies === false) {
          this.form.verTodoStatuses = true
          this.form.verTodoCompanies = true
          this.doFeedback(i18n.t('feedback.info.anyrole_permissions_overwritten'), 'info')
        }
      }
    },
    toggleDialogs: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      if (!emailRegex.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newUserHandler(formName)
      } else {
        this.updateUserHandler(formName)
      }
    },
    newUserHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            Nombre: this.form.name,
            Email: this.form.email,
            Password: this.form.password,
            idDistribuidor: this.form.idDistribuidor,
            idRol: this.form.roleId,
            idCliente: this.form.clienteId,
            VerTodoEstados: this.form.roleId !== 9 ? this.form.verTodoStatuses : false,
            VerTodoEmpresas: this.form.roleId !== 9 ? this.form.verTodoCompanies: false,
            idTipoAutenticacion: this.form.roleId !== 9 ? this.form.tipoAuth : 0,
            IdCifs: [],
            Idioma: this.form.idioma
          }
          if (!this.hasAADIntegration && !this.hasSAML2Integration) {
            params.idTipoAutenticacion = this.tiposAuthFiltered.find(x => x.key === 'Local')?.value ?? 0
          }
          const response = await newUser(params)
          if (response.blnError === true) {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateUserHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            idUsuario: this.form.id,
            Email: this.form.email,
            Nombre: this.form.name,
            VerTodoEstados: this.form.roleId !== 9 ? this.form.verTodoStatuses : false,
            VerTodoEmpresas: this.form.roleId !== 9 ? this.form.verTodoCompanies: false,
            idTipoAutenticacion: this.form.roleId !== 9 ? this.form.tipoAuth : 0,
            idRol: this.form.roleId,
            Idioma: this.form.idioma
          }
          if (!this.hasAADIntegration && !this.hasSAML2Integration) {
            params.idTipoAutenticacion = this.tiposAuthFiltered.find(x => x.key === 'Local')?.value ?? 0
          }
          const response = await updateUser(params)
          if (response.blnError === false) {
            this.disableRoutes()
            this.$message({
              type: 'success',
              message: i18n.t('feedback.success.saved_data_msg')
            })
            if (this.isSameUser) {
              this.$store.commit('auth/setLocale', params.Idioma)
            }
            this.updateView()
          } else {
            this.$message({
              type: 'error',
              message: response.msgError
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: i18n.t('feedback.error.process_data_error')
          })
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    disableRoutes: function () {
      const isDisabledByRol = (this.form.roleId === 3 || this.form.roleId === 7 || this.form.roleId === 8)
      const isDisabledByProvider = this.form.roleId === 9
      const objDisableRoutes = {
        disableGroups: isDisabledByRol || isDisabledByProvider,
        disableStatuses: this.form.verTodoStatuses || isDisabledByRol || isDisabledByProvider,
        disableCompanies: this.form.verTodoCompanies || isDisabledByRol || isDisabledByProvider,
        disableProviderCompanies: !isDisabledByProvider
      }
      bus.$emit('disableOptionsUser', objDisableRoutes)
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/users' })
    },
    downloadData: async function (id) {
      let user = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idUsuario: id
        }
        user = await getUser(params)
        this.setUser(user.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return user
    },
    setUser: function (user) {
      const role = this.roles.find(r => r.id === user.idRol)
      const arrayAuthTypes = this.$store.getters['config/TIPOS_AUTH']
      const tipoAuth = arrayAuthTypes.find(r => r.id === user.idTipoAutenticacion)
      this.form.id = user.idUsuario
      this.form.name = user.Usuario
      this.form.email = user.Email
      this.form.company = user.Empresa
      this.form.active = user.active
      this.form.created_at = user.created_at
      this.form.roleId = role?.id ?? user.idRol
      this.form.staticRoleId = role?.id ?? user.idRol
      this.form.clienteId = user.idCliente
      this.form.verTodoStatuses = user.VerTodoEstados
      this.form.verTodoCompanies = user.VerTodoEmpresas
      this.form.tipoAuth = tipoAuth?.id ?? user.idTipoAutenticacion
      this.form.idDistribuidor = user.idDistribuidor
      this.disableRoutes()
      this.loadedFirstTime = true
      this.form.idioma = user.LangCode
    },
    generatePassword: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
